import { render, staticRenderFns } from "./IngredientSelect.vue?vue&type=template&id=0f39f2dc&scoped=true&"
import script from "./IngredientSelect.vue?vue&type=script&lang=js&"
export * from "./IngredientSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f39f2dc",
  null
  
)

export default component.exports